import { render } from "./BankIdRegister.vue?vue&type=template&id=58782862&scoped=true"
import script from "./BankIdRegister.vue?vue&type=script&lang=js"
export * from "./BankIdRegister.vue?vue&type=script&lang=js"

import "./BankIdRegister.vue?vue&type=style&index=0&id=58782862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58782862"]])

export default __exports__